// extracted by mini-css-extract-plugin
export default {"profile":"ProfileIcon_profile__ufDcU","menu":"ProfileIcon_menu__aHGjZ"};